import React, { useEffect, useState } from 'react';

import type { TFrame } from '@vlabs/monokit/features/classify-deepfake';
import { ClassifyDeepfakeButton } from '@vlabs/monokit/features/classify-deepfake';
import { FaceSample } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { Score } from './base-result-item/Score';
import st from './DeepfakeFaceResultItem.module.sass';
import { ResultItem } from '../../../../components/result-item/ResultItem';
import type { TResultStatus } from '../../check-tag/CheckTag';
import { CheckTag } from '../../check-tag/CheckTag';

interface DeepfakeFaceResultItemProps {
  prediction: string;
  score: number;
  frames: TFrame[];
  face: Promise<string>;
}

const kindMap: Record<string, TResultStatus> = {
  fake: 0,
  real: 1,
};

function DeepfakeFaceResultItem({
  prediction,
  score,
  frames,
  face,
}: DeepfakeFaceResultItemProps): React.JSX.Element {
  const { t } = useTranslation();
  const [faceSrc, setFaceSrc] = useState<string>();

  useEffect(() => {
    face.then(setFaceSrc);
  }, [face]);

  return (
    <div className={st.Root}>
      <FaceSample
        size="small"
        src={faceSrc}
      />
      <div className={st.ResultContainer}>
        <ResultItem
          className={st.Result}
          label={t('Deepfake')}
        >
          <Score value={score} />
          <CheckTag
            kind={kindMap[prediction] as TResultStatus}
            value={t(`checks:result panel.results.deepfake_states.${prediction}`)}
          />
        </ResultItem>
        <ClassifyDeepfakeButton
          disabled={prediction !== 'fake'}
          frames={frames}
        />
      </div>
    </div>
  );
}

export { DeepfakeFaceResultItem };
